<template>
  <div class="w-100">
    <div class="mb-4">
      <div
        v-for="reason in reasons"
        :key="reason.legend"
        class="mb-3"
      >
        <BaseCheckbox v-model="reason.state">{{ reason.legend }}</BaseCheckbox>
      </div>
    </div>

    <div :class="$style.cancellation__heading2">Dê a sua opinião:</div>
    <PrimaryInput
      v-model="feedback"
      placeholder="O que precisamos melhorar?"
      type="textarea"
      class="w-100"
    />

    <div>
      <SecondaryButton
        v-if="isFormValid"
        :class="[$style.cancellation__button2]"
        class="mr-4"
        @click="() => goBackFromCancellation({ type: 'FEEDBACK' })"
      >Continuar jornada</SecondaryButton>

      <button
        v-if="isFormValid"
        :class="[$style.cancellation__button1]"
        @click="submit"
      >Prosseguir cancelamento</button>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import BaseCheckbox from '@/components/form/BaseCheckbox'
import PrimaryInput from '@/components/form/PrimaryInput'
import useCancellation from '@/components/cancellation/cancellation';
import SecondaryButton from '@/components/buttons/SecondaryButton'

export default {
  components: {
    BaseCheckbox,
    PrimaryInput, 
    SecondaryButton
  },
  setup(props, { emit }) {
    const reasons = ref([
      { state: false, legend: 'O valor está pesando no orçamento' },
      { state: false, legend: 'Sem tempo para utilizar' },
      { state: false, legend: 'Não encontrei o curso que queria' },
      { state: false, legend: 'Já assisti os cursos que tinha interesse' },
      { state: false, legend: 'Achei o conteúdo raso ou incompleto' },
      { state: false, legend: 'Problemas técnicos na plataforma' },
      { state: false, legend: 'Me senti perdido sobre o conteúdo' },
    ].sort(() => Math.random() - 0.5).concat([
      { state: false, legend: 'Outro' }
    ]))

    const feedback = ref('')

    const { goBackFromCancellation } = useCancellation()

    const reasonsOutput = computed(() => reasons.value
      .filter(reason => reason.state)
      .map(reason => reason.legend)
    )

    const isFormValid = computed(() => reasonsOutput.value.length && feedback.value.length)

    function submit () {
      emit('submit', {
        reasons: reasonsOutput.value,
        feedback: feedback.value
      })
    }

    return {
      reasons,
      feedback,
      reasonsOutput,
      isFormValid,
      goBackFromCancellation,
      submit
    }
  }
}

</script>

<style lang="scss" module>
@import "~@/components/cancellation/cancellation.scss";
</style>